import React from 'react';
import { getAbout } from '../../data/API';
import {Helmet} from "react-helmet";
import { useNavigate } from 'react-router-dom';
import './index.css';

export default function index(props) {
  const navigate = useNavigate();
  const [about, setabout] = React.useState({});
  props.setFooteroffice(true);
  props.setshowHideFooter(false);
  const callApi = () => {
    getAbout().then((res) => {
      setabout(res.data);
    });
  };
  React.useEffect(() => {
    callApi();
  }, []);

  return (
    <>
      <Helmet>
      <title>A green and convenient solution for your next move | BlueBox</title>
      <meta name="description" content="We deliver clean, reusable, tree-free boxes and recyclable and/or biodegradable moving supplies directly to your door. Who says green can't be convenient?" />
      <meta name="keywords" content="about bluebox, reusable moving boxes San francisco, reusable moving boxes San Jose, reusable moving boxes Oakland" />
      </Helmet>

      {/* New Hero Section with Ocean Image */}
      <section className="about-hero-ocean-section" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/about-us-ocean.png)` }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="about-hero-title">About BlueBox</h1>
              <p className="about-hero-subtitle">Better Boxes. Better Planet.</p>
            </div>
          </div>
        </div>
      </section>
      {/* New Hero Section End */}

      {/* About Intro Paragraph Section */}
      <section className="about-intro-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="about-intro-text">
                We started BlueBox with a simple belief: moving shouldn&apos;t trash the planet. So instead of buying flimsy, single-use cardboard, you rent sturdy, reusable BlueBoxes—delivered to your door, picked up when you&apos;re done. It&apos;s greener, easier, and usually cheaper than the old way.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* About Intro Paragraph Section End */}

      <section className="move-hero-about position-relative ">
        <div className="container">
          {/* <div className="text-center">
                        <h1 className="text-white" data-aos="fade-down" data-aos-delay="0" data-aos-duration="1000">
                           About Us
                        </h1>
                       
                        <button className="btn btn-primary px-4 mt-2" data-aos="fade-down" data-aos-delay="400" data-aos-duration="1000"  >Order Now</button>
                    </div> */}
          <div className="about_icon">
            <h1>PRODUCING ONE TON OF CARDBOARD REQUIRES</h1>
            <div className="row">
              <div className="col-md-4">
                <img src="img/trees.png" alt="" />
                <h4>17</h4>
                <p>Trees</p>
              </div>
              <div className="col-md-4">
                <img src="img/oil.png" alt="" />
                <h4>79</h4>
                <p>Gallons of Oil</p>
              </div>
              <div className="col-md-4">
                <img src="img/water.png" alt="" />
                <h4>7000</h4>
                <p>Gallons of Water</p>
              </div>
            </div>
            <div className="aftricn">
              <p>In the US, over 17,000 tons of cardboard end up in landfills each year</p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Brand Promise Section */}
      <section className="about-core-brand-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="core-brand-heading">Core Brand Promise</h2>
              <p className="core-brand-text">
                At BlueBox, we believe moving shouldn&apos;t cost the Earth. BlueBox is more than just a smarter way to move — it&apos;s a mission-driven service that helps protect our planet. By replacing disposable cardboard with durable, reusable moving boxes, we cut down on waste, save trees, and keep plastics and debris out of our oceans.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Core Brand Promise Section End */}

      {/* BlueBox 4 Pillars Section */}
      <section className="about-pillars-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h2 className="pillars-title">BlueBox 4 pillars</h2>
            </div>
          </div>
          <div className="pillars-content">
            <div className="pillar-item">
              <div className="pillar-icon-wrapper">
                <img src="img/asset1.png" alt="Reducing Waste" className="pillar-icon" />
              </div>
              <div className="pillar-text">
                <h3 className="pillar-heading">Reducing Waste & Deforestation</h3>
                <ul className="pillar-list">
                  <li>Every BlueBox rental prevents dozens of single-use cardboard boxes from being produced and discarded.</li>
                  <li>This <strong>reduces demand for deforestation and minimizes landfill overflow.</strong></li>
                </ul>
              </div>
            </div>

            <div className="pillar-item">
              <div className="pillar-icon-wrapper">
                <img src="img/asset2.png" alt="Protecting Oceans" className="pillar-icon" />
              </div>
              <div className="pillar-text">
                <h3 className="pillar-heading">Protecting Oceans & Waterways</h3>
                <ul className="pillar-list">
                  <li>Traditional moving waste often ends up as litter that finds its way into waterways and oceans.</li>
                  <li>By using BlueBox containers (designed for <strong>400+ uses</strong>), we dramatically reduce the flow of harmful waste into the ocean.</li>
                  <li><strong>Each box is recyclable</strong> at the end of its life, creating a true closed-loop system.</li>
                </ul>
              </div>
            </div>

            <div className="pillar-item">
              <div className="pillar-icon-wrapper">
                <img src="img/asset3.png" alt="Lowering Carbon Footprint" className="pillar-icon" />
              </div>
              <div className="pillar-text">
                <h3 className="pillar-heading">Lowering Carbon Footprint</h3>
                <ul className="pillar-list">
                  <li>Manufacturing reusable BlueBoxes once creates a far lower lifetime carbon footprint than producing hundreds of disposable cardboard boxes.</li>
                  <li>Fewer delivery trips and waste pickups mean <strong>fewer CO₂ emissions</strong> overall.</li>
                </ul>
              </div>
            </div>

            <div className="pillar-item">
              <div className="pillar-icon-wrapper">
                <img src="img/asset4.png" alt="Sustainable Lifestyle" className="pillar-icon" />
              </div>
              <div className="pillar-text">
                <h3 className="pillar-heading">Sustainable Lifestyle Choice</h3>
                <ul className="pillar-list">
                  <li>Customers can feel good knowing their move is actively supporting ocean conservation.</li>
                  <li>Choosing BlueBox is an easy way to align everyday actions with <strong>environmental values.</strong></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* BlueBox 4 Pillars Section End */}

      {/* About Us Sea Image Section */}
      <section className="about-sea-image-section">
        <img src={`${process.env.PUBLIC_URL}/img/about-us-sea.png`} alt="About Us" className="about-sea-image-sm" />
        <div className="container">
         <img src={`${process.env.PUBLIC_URL}/img/about-us-sea.png`} alt="About Us" className="about-sea-image " />
        </div>
      </section>
      {/* About Us Sea Image Section End */}

      {/* Why the Ocean Is Our North Star Section */}
      <section className="about-ocean-north-star-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="ocean-north-star-heading">Why the Ocean Is Our North Star</h2>
              <p className="ocean-north-star-text">
                Plastic and packaging waste doesn&apos;t just disappear—it leaks into waterways and, ultimately, our oceans. Globally, an estimated 11 million metric tons of plastic enter the ocean each year. Choosing reusables keeps materials in circulation and reduces the volume of single-use stuff headed for landfills, storm drains, and shorelines.
              </p>
              <p className="ocean-north-star-text">
                <strong>Your move matters.</strong> Every time you choose BlueBox, you&apos;re choosing to keep waste out of landfills and plastic out of our oceans — while making your move easier, faster, and more affordable.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Why the Ocean Is Our North Star Section End */}

      {/* Our Ocean-First Commitments Section */}
      <section className="ocean-commitments-section">
        <div className="ocean-wave-bg"></div>
        <div className="ocean-wave-top">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="ocean-commitments-heading">Our Ocean-First Commitments</h2>
            </div>
          </div>
          <div className="ocean-commitments-content">
            <div className="commitment-item">
              <h3 className="commitment-title">Reduce single-use waste</h3>
              <p className="commitment-description">Every rental keeps disposable packaging out of the system.</p>
            </div>
            <div className="commitment-item">
              <h3 className="commitment-title">Continuous Improvement</h3>
              <p className="commitment-description">We&apos;re always refining routes, materials, and processes to cut emissions and increase reuse cycles.</p>
            </div>
            <div className="commitment-item">
              <h3 className="commitment-title">Community Impact</h3>
              <p className="commitment-description">We champion local clean-up efforts and educational initiatives that protect Bay Area waterways.</p>
            </div>
          </div>
        </div>
        </div>
      </section>
      {/* Our Ocean-First Commitments Section End */}

      {/* The Blue in BlueBox Section */}
      <section className="about-blue-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="blue-content">
                <h2 className="blue-heading">
                  The <span className="blue-text">Blue</span> in BlueBox
                </h2>
                <p className="blue-paragraph">
                  We&apos;re Bay Area folks who happen to be ocean people—surfers, sailors, tide-pool wanderers. The ocean gives us a bigger &quot;why&quot; for the work we do: make moving simpler for people and gentler on the planet we all share.
                </p>
                <p className="blue-highlight">
                  <strong>Blue isn&apos;t just our color. It&apos;s our cause.</strong>
                </p>
                <p className="blue-paragraph">
                  Every BlueBox is a step toward cleaner oceans, healthier communities, and a planet worth passing on.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="blue-image-wrapper">
                <img src={`${process.env.PUBLIC_URL}/img/about-us-dolphine.png`} alt="Dolphin" className="blue-dolphin-image" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* The Blue in BlueBox Section End */}

      {/* How BlueBox Shrinks Moving Waste Section */}
      <section className="about-shrinks-waste-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h2 className="shrinks-waste-heading">How BlueBox Shrinks Moving Waste</h2>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-md-4">
              <div className="waste-item">
                <div className="waste-icon-wrapper">
                  <img src="img/rent-reuse-icon.png" alt="Rent, reuse, return" className="waste-icon" />
                </div>
                <h3 className="waste-item-title">Rent, reuse, return</h3>
                <p className="waste-item-description">
                  One durable BlueBox replaces dozens of single-use boxes and tape for move after move—no assembly, no soggy cardboard, no landfill guilt.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="waste-item">
                <div className="waste-icon-wrapper">
                  <img src="img/repeat-life-icon.png" alt="Designed for repeat life" className="waste-icon" />
                </div>
                <h3 className="waste-item-title">Designed for repeat life</h3>
                <p className="waste-item-description">
                  Reuse beats one-and-done; durable totes are built to stay in the loop rather than the bin. (Multiple life-cycle studies show reusables can reduce environmental impact when used over many trips and handled efficiently.)
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="waste-item">
                <div className="waste-icon-wrapper">
                  <img src="img/logistics-icon.png" alt="Smarter logistics" className="waste-icon" />
                </div>
                <h3 className="waste-item-title">Smarter logistics</h3>
                <p className="waste-item-description">
                  Consolidated deliveries and pickups mean fewer store runs, fewer wasted trips, and fewer &quot;emergency&quot; box buys—small choices that add up.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* How BlueBox Shrinks Moving Waste Section End */}

      {/* What You'll Notice on Day One Section */}
      <section className="about-day-one-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="day-one-heading">What You&apos;ll Notice on Day One</h2>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-md-6">
              <div className="day-one-card">
                <h3 className="day-one-card-title">Faster packing</h3>
                <p className="day-one-card-description">
                  Lids snap shut, boxes stack perfectly; your space stays organized.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="day-one-card">
                <h3 className="day-one-card-title">Less stress</h3>
                <p className="day-one-card-description">
                  We deliver to your door and pick up when you&apos;re finished. You focus on the move, not the mess.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* What You'll Notice on Day One Section End */}

      {/* Join the Blue Move Section */}
      <section className="about-join-blue-section">
        <div className="container">
          <div className="row align-items-end">
            <div className="col-md-9">
              <div className="join-blue-content">
                <h2 className="join-blue-heading">
                  Join the <span className="blue-text">Blue</span> Move
                </h2>
                <p className="join-blue-text">
                  Ready to ditch the cardboard chaos and do right by the coast? Rent BlueBoxes for your next move. Your back (and the bay) will thank you.
                </p>
              </div>
            </div>
            <div className="col-md-3 text-end">
              <button className="btn btn-danger btn-lg join-blue-btn w-100" onClick={() => navigate('/moving-boxes')}>Order boxes</button>
            </div>
          </div>
        </div>
      </section>
      {/* Join the Blue Move Section End */}
    </>
  );
}